<template>
  <div class = "card-curvey" style="">
    <h3>Users Reply Back per Day</h3>
    <apex-chart type="line" :options="options" :series="series" :height="300"></apex-chart>
  </div>
</template>

<script>
  import apexChart from 'vue-apexcharts'
  export default {
    name: "replyBackStatus",
    components: {
      apexChart
    },
    props: {
      replyBackStatus: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
    data() {
      return {
        options: {
          chart: {
            id: 'session-date',
            height: 300,
          },
          colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#833B2B'],
          markers: {
            size: 3,
            strokeColors: '#fff',
            strokeWidth: 2,
            strokeOpacity: 0.9,
            strokeDashArray: 0,
            fillOpacity: 1,
            discrete: [],
            shape: "circle",
            radius: 2,
            offsetX: 0,
            offsetY: 0,
            onClick: undefined,
            onDblClick: undefined,
            hover: {
              size: undefined,
              sizeOffset: 3
            }
          },
          stroke: {},
          xaxis: {
            type: 'datetime',
            title: {
              text: ' '
            }
          },
          yaxis: {
            show: false,
            title: {

            }
          }
        },
        series: []
      }
    },
    mounted() {
      this.getChartsData()
    },
    methods: {
      getChartsData() {
        let data = []
        for (let i=0; i<this.replyBackStatus.length;i++) {
          data.push({
            x: this.replyBackStatus[i].date,
            y: this.replyBackStatus[i].count
          })
        }

        console.log(data)
        this.series.push({
          name: 'Users',
          data: data,
          type: 'line'
        })
      }
    }
  }
</script>

<style scoped>

</style>
